import React from 'react'

import ImageSlider from '_components/ImageSlider'
import QuantityStepper from './QuantityStepper'

const ProductSplitRow = ({
  splitCasePurchase,
  quantity,
  soldOut,
  edittingOrder,
  onDecrement,
  onIncrement,
  onInputChange,
  onInputCommit,
}) => {
  const filled = splitCasePurchase.orderCount % splitCasePurchase.itemsPerCase
  const remaining = splitCasePurchase.itemsPerCase - filled

  return (
    <div className="edv2-product-row edv2-product-row--split">
      <div className="edv2-product-row__image-group">
        <div className="edv2-product-row__image">
          <ImageSlider
            images={splitCasePurchase.photoUrl ? [splitCasePurchase.photoUrl] : []}
            alt={splitCasePurchase.name}
          />
        </div>
        <div className="edv2-product-row__stats">{splitCasePurchase.orderCount || 0} order(s) made</div>
      </div>

      <div className="edv2-product-row__content">
        <div className="edv2-product-row__header">
          <div className="edv2-product-row__name">{splitCasePurchase.name}</div>
          <div className="edv2-product-row__price">
            <span>
              ${splitCasePurchase.costPerItem?.toFixed(2)}
            </span>
          </div>
        </div>

        <div className="edv2-product-row__meta">Individual pieces (split case)</div>

        {splitCasePurchase.description && (
          <div className="edv2-product-row__desc">{splitCasePurchase.description}</div>
        )}

        <div className="edv2-split-progress-section">
          <div className="edv2-split-progress-header">
            <span>Case fill</span>
            <span style={{ fontWeight: 600 }}>{filled} / {splitCasePurchase.itemsPerCase}</span>
          </div>
          <div className="edv2-split-progress-bar-wrapper">
            <div
              className="edv2-split-progress-bar-fill"
              style={{ width: `${(filled / splitCasePurchase.itemsPerCase) * 100}%` }}
            />
          </div>
          <div className="edv2-progress__hint">Need {remaining} more to fulfill</div>
        </div>

        <div className="edv2-product-row__footer">

          {(!soldOut || edittingOrder) && (
            <div className="edv2-product-row__action">
              <QuantityStepper
                value={quantity}
                onDecrement={onDecrement}
                onIncrement={onIncrement}
                onInputChange={(e) => onInputChange(parseInt(e.target.value, 10) || 0)}
                onInputBlur={(e) => onInputCommit(parseInt(e.target.value, 10) || 0)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductSplitRow
